import styled from "styled-components";

export const LoadingContainer = styled.div`
    position:absolute;
    width: 100%;
    text-align: center;
    top:50%;
    left:0%;
`